const actions = {
  AUTOCOMPLETE: "AUTOCOMPLETE",
  SEARCH: "SEARCH",
  BOUNDS_CHANGED: "BOUNDS_CHANGED",
  MOVING_MAP: "MOVING_MAP",
  LOAD_REGION_DATA: "LOAD_REGION_DATA",
  TRACK_CLICK: "TRACK_CLICK"
};

export default actions;



// WEBPACK FOOTER //
// ./const/actions.js